"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var History_1 = __importDefault(require("@src/History"));
var reduxStores_1 = __importDefault(require("@src/reduxStores"));
var react_redux_1 = require("react-redux");
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
// Icons
var train_svg_1 = __importDefault(require("@src/containers/SubStories/Header/icons/train.svg"));
var AddIcon_svg_1 = __importDefault(require("@src/containers/FAQNodes/icons/AddIcon.svg"));
// Store
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var store_1 = __importDefault(require("@src/store"));
var maps_1 = require("./maps");
// Actions
var dispatcher_1 = require("@src/dispatcher");
var api_1 = require("@src/api");
var BotActions_1 = require("@src/actions/BotActions");
var api_2 = require("@src/containers/AIAgents/store/api");
var AuditLogs_1 = require("@src/utils/AuditLogs");
var DomainAPI_1 = require("@src/api/DomainAPI");
var DomainActions_1 = require("@src/actions/DomainActions");
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
// Utils
var utils_1 = require("./utils");
// Components
var GraphButton_1 = __importDefault(require("../SubStories/GraphButton"));
var Training_1 = __importDefault(require("../SubStories/Header/components/TrainButton/Training"));
var ActionCard_1 = __importDefault(require("./components/ActionCard"));
var StyledComponets_1 = require("./components/StyledComponets");
var actionTypes_1 = __importDefault(require("./store/actionTypes"));
var PING_INTERVAL = 5000;
var AIAgentsComponent = function () {
    var _a;
    var _b = react_1.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(false), trainingInProgress = _c[0], setTrainingInProgress = _c[1];
    var _d = react_1.useState(false), needsTraining = _d[0], setNeedsTraining = _d[1];
    var domain = (((_a = CommonStore_1["default"].getMetaTags().domain) === null || _a === void 0 ? void 0 : _a.length) &&
        CommonStore_1["default"].getMetaTags().domain) ||
        JSON.parse(localStorage.getItem('ww_iva'));
    var domainId = domain === null || domain === void 0 ? void 0 : domain.id;
    var domainName = domain.title;
    var reduxDispatch = react_redux_1.useDispatch();
    var agentsList = react_redux_1.useSelector(maps_1.stateToProps).agentsList;
    var _e = maps_1.dispatchToProps(reduxDispatch), setAgentsList = _e.setAgentsList, setCurrentAgentData = _e.setCurrentAgentData, setDomainName = _e.setDomainName, setCurrentActionData = _e.setCurrentActionData;
    var isTrainButtonDisabled = function () {
        return store_1["default"].isProductionEnv();
    };
    var onAgentConfigure = function (agentId) {
        var agentData = agentsList.find(function (agent) { return agent.id == agentId; });
        setCurrentAgentData(agentData);
        utils_1.redirectToAgent(agentId, domainId);
    };
    var fetchAllAgents = function () {
        setIsLoading(true);
        api_2.getAgents(domainId)
            .then(function (_a) {
            var _b;
            var success = _a.success, response = _a.response;
            if (success) {
                var agentsList_1 = response.body;
                if (agentsList_1.length > 0) {
                    setAgentsList(agentsList_1);
                    // As currently we have only one agent configuration so we're redirecting to that agent.
                    var currentAgent = (_b = agentsList_1.filter(function (agent) { return agent.agent_type === 0; })) === null || _b === void 0 ? void 0 : _b[0];
                    setCurrentAgentData(currentAgent);
                    History_1["default"].push("/ai-agents-project/" + domainId + "/agent/" + currentAgent.id);
                }
                else {
                    BotActions_1.createAlert('Something went wrong. No agent is present on this project', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    History_1["default"].push('/');
                }
            }
            else {
                BotActions_1.createAlert(response.error || 'Error occurred while fetching agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            }
            setIsLoading(false);
        })["catch"](function (error) {
            setIsLoading(false);
            api_1.captureException(error);
        });
    };
    var trainAIAgents = function () {
        var domainTitle = domain.title;
        var domainId = domain.id;
        var headers = AuditLogs_1.getAuditHeaders({
            domain: domain,
            eventName: 'train_ai_agents',
        });
        BotActions_1.deployAIAgents(domainTitle, headers, domainId, {
            action: 'ai_agents',
        }, function () {
            // Set the in training flag as true and then again fetch after 3 secs from backend to confirm this.
            setTrainingInProgress(true);
        });
    };
    react_1["default"].useEffect(function () {
        var _a, _b;
        DomainActions_1.getDomainData((_b = (_a = CommonStore_1["default"].getMetaTags()) === null || _a === void 0 ? void 0 : _a.domain) === null || _b === void 0 ? void 0 : _b.id).then(function (res) {
            console.log('api called', res);
            if (res) {
                dispatcher_1.dispatch(MogamboConstants_1.ActionTypes.SET_CURRENT_BOT_SETTINGS, {
                    settings: res,
                });
                reduxDispatch({
                    type: actionTypes_1["default"].SET_DOMAIN_DATA,
                    data: res,
                });
            }
        });
        setDomainName(domainName);
        fetchAllAgents();
    }, [domainId]);
    var fetchStatus = react_1["default"].useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, aiAgentsTrainStatus, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!domain.title)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, DomainAPI_1.getDomainStatus(domain.title)];
                case 2:
                    _a = (_b.sent()).body.ai_agents_train_status, aiAgentsTrainStatus = _a === void 0 ? {} : _a;
                    setTrainingInProgress(aiAgentsTrainStatus.training_started);
                    setNeedsTraining(aiAgentsTrainStatus.needs_training);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [domain.id]);
    react_1["default"].useEffect(function () {
        var interval = setInterval(function () {
            fetchStatus();
        }, PING_INTERVAL);
        return function () {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domainId]);
    react_1["default"].useEffect(function () {
        if (![2, 3, 4].includes(domain.domain_type)) {
            History_1["default"].push('/');
        }
        else {
            // Set the empty object so that current action data is reset when someone opens the agents page
            setCurrentActionData({});
        }
    }, [domainId]);
    if (isLoading) {
        return react_1["default"].createElement(StyledComponets_1.StyledOverlayLoader, null);
    }
    return (react_1["default"].createElement(box_1["default"], { padding: "24px", style: { overflowY: 'scroll' }, flexDirection: "column" },
        react_1["default"].createElement(box_1["default"], { style: { gap: '24px' } },
            react_1["default"].createElement(box_1["default"], { padding: "0", marginBottom: "16px", style: { display: 'grid', flex: 2, alignContent: 'baseline' } },
                react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, "AI Agents"),
                react_1["default"].createElement(StyledComponets_1.StyledText, null, "All your agents are listed below. Click on \"Configure\" to set them up.")),
            react_1["default"].createElement(box_1["default"], { style: { display: 'grid', alignContent: 'baseline' } }, isTrainButtonDisabled() ? (react_1["default"].createElement(GraphButton_1["default"], { disabled: true, onClick: trainAIAgents, trainButton: true, blink: needsTraining && !isTrainButtonDisabled() },
                react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                trainingInProgress ? (react_1["default"].createElement(Training_1["default"], { text: 'Training AI Agents' })) : ('Train AI Agents'))) : (react_1["default"].createElement(GraphButton_1["default"], { disabled: trainingInProgress || isTrainButtonDisabled(), onClick: trainAIAgents, trainButton: true, blink: needsTraining && !isTrainButtonDisabled() },
                react_1["default"].createElement(icon_1["default"], { src: train_svg_1["default"] }),
                trainingInProgress ? (react_1["default"].createElement(Training_1["default"], { text: 'Training AI Agents' })) : ('Train AI Agents'))))),
        react_1["default"].createElement(box_1["default"], { width: "746px", flexDirection: "column" }, agentsList === null || agentsList === void 0 ? void 0 : agentsList.map(function (agent) { return (react_1["default"].createElement(ActionCard_1["default"], { key: agent.id, title: agent.title, onConfigure: function () { return onAgentConfigure(agent.id); } })); })),
        react_1["default"].createElement(StyledComponets_1.StyledAddActionButton, null,
            react_1["default"].createElement(icon_1["default"], { src: AddIcon_svg_1["default"], onClick: function () { } }),
            react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "blue.haptik", onClick: function () { } },
                ' ',
                "Add Agent"))));
};
var AIAgents = function (props) {
    return (react_1["default"].createElement(react_redux_1.Provider, { store: reduxStores_1["default"] },
        react_1["default"].createElement(AIAgentsComponent, __assign({}, props))));
};
exports["default"] = AIAgents;
